import React from "react";
import PropTypes from "prop-types";
import Modalstyle from "./modal.module.scss";
import MonthlyKpiReportCustomerTable from "../table/all-tables/reportable/monthlykpireport/modaltabel/customer/MonthlyKpiReportCustomerTable";
import { COLUMNS } from "../table/all-tables/reportable/monthlykpireport/modaltabel/customer/columns";
import { kpiReport, buttonName } from "../../locales/en";
import CommonModal from "./CommonModal";
import { CLIENT_DETAILS } from "../../route/paths";
import { CUSTOMERDETAILS, NAME } from "../../utils/constants/appConstants";

const MonthlyKpiReportCustomerModal = ({
  isOpen,
  toggle,
  invoiceIdsListRef,
  filterType
}) => {
  const footerButtons = [
    {
      label: buttonName?.close,
      className: "btn btn-secondary",
      onClick: () => toggle(false)
    }
  ];

  return (
    <CommonModal
      isOpen={isOpen}
      toggle={toggle}
      title={kpiReport?.customerModal?.title}
      modalClassName="modal-lg modal-dialog-scrollable"
      bodyClassName={Modalstyle.refMonthlySingleContent}
      footerButtons={footerButtons}
    >
      <MonthlyKpiReportCustomerTable
        invoiceIdsListRef={invoiceIdsListRef}
        columnsConfig={COLUMNS}
        detailsKey={CUSTOMERDETAILS}
        linkColumnId={NAME}
        buildLink={(id) => CLIENT_DETAILS(id)}
        filterType={filterType}
      />
    </CommonModal>
  );
};
MonthlyKpiReportCustomerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  invoiceIdsListRef: PropTypes.object,
  filterType: PropTypes.string
};

export default MonthlyKpiReportCustomerModal;
